import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import constants from "../../constants";
import http from "../http";

var getFolderContent = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var folderId, _ref$params, params, response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            folderId = _ref.folderId, _ref$params = _ref.params, params = _ref$params === void 0 ? {} : _ref$params;
            _context.next = 3;
            return http.get("".concat(constants.API_URL_V1, "/materials/folders/").concat(folderId), {
              params: params
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getFolderContent(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var getNote = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var noteId, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            noteId = _ref3.noteId;
            _context2.next = 3;
            return http.get("".concat(constants.API_URL, "/materials/notes/").concat(noteId));

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getNote(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var addNoteComment = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var noteId, content, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            noteId = _ref5.noteId, content = _ref5.content;
            _context3.next = 3;
            return http.post("".concat(constants.API_URL, "/materials/notes/").concat(noteId, "/comments"), {
              content: content
            });

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function addNoteComment(_x3) {
    return _ref6.apply(this, arguments);
  };
}();

var deleteNoteComment = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
    var noteId, commentId, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            noteId = _ref7.noteId, commentId = _ref7.commentId;
            _context4.next = 3;
            return http["delete"]("".concat(constants.API_URL, "/materials/notes/").concat(noteId, "/comments/").concat(commentId));

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function deleteNoteComment(_x4) {
    return _ref8.apply(this, arguments);
  };
}();

var updateNote = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref9) {
    var noteId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            noteId = _ref9.noteId, data = _ref9.data, onUploadProgress = _ref9.onUploadProgress;
            _context5.next = 3;
            return http.patch("".concat(constants.API_URL, "/materials/notes/").concat(noteId), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function updateNote(_x5) {
    return _ref10.apply(this, arguments);
  };
}();

var copyMaterial = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref11) {
    var materialId, data, response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            materialId = _ref11.materialId, data = _ref11.data;
            _context6.next = 3;
            return http.post("".concat(constants.API_URL, "/materials/").concat(materialId, "/copy"), data);

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function copyMaterial(_x6) {
    return _ref12.apply(this, arguments);
  };
}();

var moveMaterial = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref13) {
    var materialId, data, response;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            materialId = _ref13.materialId, data = _ref13.data;
            _context7.next = 3;
            return http.post("".concat(constants.API_URL, "/materials/").concat(materialId, "/move"), data);

          case 3:
            response = _context7.sent;
            return _context7.abrupt("return", response);

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function moveMaterial(_x7) {
    return _ref14.apply(this, arguments);
  };
}();

var editMaterial = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref15) {
    var materialId, material, response;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            materialId = _ref15.materialId, material = _ref15.material;
            _context8.next = 3;
            return http.patch("".concat(constants.API_URL, "/materials/").concat(materialId), material);

          case 3:
            response = _context8.sent;
            return _context8.abrupt("return", response);

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function editMaterial(_x8) {
    return _ref16.apply(this, arguments);
  };
}();

var deleteMaterial = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref17) {
    var materialId, response;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            materialId = _ref17.materialId;
            _context9.next = 3;
            return http["delete"]("".concat(constants.API_URL, "/materials/").concat(materialId));

          case 3:
            response = _context9.sent;
            return _context9.abrupt("return", response);

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function deleteMaterial(_x9) {
    return _ref18.apply(this, arguments);
  };
}();

var shareMaterial = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref19) {
    var materialId, data, response;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            materialId = _ref19.materialId, data = _ref19.data;
            _context10.next = 3;
            return http.post("".concat(constants.API_URL, "/materials/").concat(materialId, "/share"), data);

          case 3:
            response = _context10.sent;
            return _context10.abrupt("return", response);

          case 5:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function shareMaterial(_x10) {
    return _ref20.apply(this, arguments);
  };
}();

var updateFolder = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref21) {
    var materialId, folder, response;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            materialId = _ref21.materialId, folder = _ref21.folder;
            _context11.next = 3;
            return http.patch("".concat(constants.API_URL, "/materials/folders/").concat(materialId), folder);

          case 3:
            response = _context11.sent;
            return _context11.abrupt("return", response);

          case 5:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function updateFolder(_x11) {
    return _ref22.apply(this, arguments);
  };
}();

var updateLink = /*#__PURE__*/function () {
  var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref23) {
    var materialId, link, response;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            materialId = _ref23.materialId, link = _ref23.link;
            _context12.next = 3;
            return http.patch("".concat(constants.API_URL, "/materials/links/").concat(materialId), link);

          case 3:
            response = _context12.sent;
            return _context12.abrupt("return", response);

          case 5:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function updateLink(_x12) {
    return _ref24.apply(this, arguments);
  };
}();

var deleteAttachment = /*#__PURE__*/function () {
  var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref25) {
    var noteId, data, response;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            noteId = _ref25.noteId, data = _ref25.data;
            _context13.next = 3;
            return http.post("".concat(constants.API_URL, "/materials/notes/").concat(noteId, "/delete-attachments"), data);

          case 3:
            response = _context13.sent;
            return _context13.abrupt("return", response);

          case 5:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function deleteAttachment(_x13) {
    return _ref26.apply(this, arguments);
  };
}();

var getAllNoteAttachments = /*#__PURE__*/function () {
  var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref27) {
    var noteId, onDownloadProgress, response;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            noteId = _ref27.noteId, onDownloadProgress = _ref27.onDownloadProgress;
            _context14.next = 3;
            return http.get("".concat(constants.API_URL, "/materials/notes/").concat(noteId, "/attachments"), {
              responseType: "blob",
              onDownloadProgress: onDownloadProgress
            });

          case 3:
            response = _context14.sent;
            return _context14.abrupt("return", response);

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function getAllNoteAttachments(_x14) {
    return _ref28.apply(this, arguments);
  };
}();

var publishMaterial = /*#__PURE__*/function () {
  var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref29) {
    var materialId, data, response;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            materialId = _ref29.materialId, data = _ref29.data;
            _context15.next = 3;
            return http.patch("".concat(constants.API_URL, "/materials/").concat(materialId, "/publish"), data);

          case 3:
            response = _context15.sent;
            return _context15.abrupt("return", response);

          case 5:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function publishMaterial(_x15) {
    return _ref30.apply(this, arguments);
  };
}();

var makeMaterialAsSeen = /*#__PURE__*/function () {
  var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_ref31) {
    var materialId, response;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            materialId = _ref31.materialId;
            _context16.next = 3;
            return http.post("".concat(constants.API_URL, "/materials/").concat(materialId, "/seen"));

          case 3:
            response = _context16.sent;
            return _context16.abrupt("return", response);

          case 5:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));

  return function makeMaterialAsSeen(_x16) {
    return _ref32.apply(this, arguments);
  };
}();

var updateFileProtection = /*#__PURE__*/function () {
  var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(_ref33) {
    var fileId, data, response;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            fileId = _ref33.fileId, data = _ref33.data;
            _context17.next = 3;
            return http.patch("".concat(constants.API_URL, "/materials/files/").concat(fileId, "/protection"), data);

          case 3:
            response = _context17.sent;
            return _context17.abrupt("return", response);

          case 5:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));

  return function updateFileProtection(_x17) {
    return _ref34.apply(this, arguments);
  };
}();

var updateFileRestriction = /*#__PURE__*/function () {
  var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_ref35) {
    var fileId, data, response;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            fileId = _ref35.fileId, data = _ref35.data;
            _context18.next = 3;
            return http.patch("".concat(constants.API_URL, "/materials/files/").concat(fileId, "/restriction"), data);

          case 3:
            response = _context18.sent;
            return _context18.abrupt("return", response);

          case 5:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));

  return function updateFileRestriction(_x18) {
    return _ref36.apply(this, arguments);
  };
}();

export default {
  getFolderContent: getFolderContent,
  getNote: getNote,
  addNoteComment: addNoteComment,
  deleteNoteComment: deleteNoteComment,
  updateNote: updateNote,
  updateFolder: updateFolder,
  deleteAttachment: deleteAttachment,
  copyMaterial: copyMaterial,
  moveMaterial: moveMaterial,
  deleteMaterial: deleteMaterial,
  updateLink: updateLink,
  editMaterial: editMaterial,
  shareMaterial: shareMaterial,
  getAllNoteAttachments: getAllNoteAttachments,
  publishMaterial: publishMaterial,
  makeMaterialAsSeen: makeMaterialAsSeen,
  updateFileProtection: updateFileProtection,
  updateFileRestriction: updateFileRestriction
};